import { useEffect, useRef } from 'react';

type Handler = () => void;

export const useEscapeKey = (handler: Handler | null): void => {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      // skip Escape already consumed by a nested control, e.g. an open select menu
      if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return;

      handlerRef.current?.();
    };

    document.addEventListener('keydown', listener);

    return () => document.removeEventListener('keydown', listener);
  }, []);
};
